<template>
  <template v-if="isSearching">
    <loading v-if="isSearching" :message="'検索中...'"></loading>
  </template>
  <template v-else>
    <scroll-table>
      <table class="list-table">
        <thead>
          <th></th>
          <th>連絡事項</th>

          <template v-if="authStore.hasPermission(PermissionConst.RENRAKU_CONTROL_SYOZOKU) || authStore.hasPermission(PermissionConst.RENRAKU_CONTROL_ALL)">
            <th>受信者</th>
            <th>既読・未読</th>
          </template>
          
        </thead>
        <tbody>
          <tr v-for="item in list" :class="{unread: item.isUnRead}">
            <td class="text-center link">
              <a @click="onClick(item.oshirase_id, item.isUnRead)">詳細</a>
            </td>
            <td class="ellipsis message">{{ item.naiyou }}</td>

            <template v-if="authStore.hasPermission(PermissionConst.RENRAKU_CONTROL_SYOZOKU) || authStore.hasPermission(PermissionConst.RENRAKU_CONTROL_ALL)">
            
              <template v-if="item.target_type == OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_ALL">
                <td class="sender">社員全員</td>
              </template>
              <template v-else-if="item.target_type == OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_BUKA">
                <td class="sender">{{ item.buka_name }}</td>
              </template>
              <template v-else-if="item.target_type == OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_KOJIN">
                <td class="sender">{{ item.jyushinsya_name }}</td>
              </template>

              <template v-if="item.target_type == OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_ALL">
                <td class="sender">-</td>
              </template>
              <template v-else-if="item.target_type == OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_BUKA">
                <td class="sender">-</td>
              </template>
              <template v-else-if="item.target_type == OptionConst.KAISYA_RENRAKU_TARGET_TYPE.TO_KOJIN">
                <td class="sender">{{ item.is_kidoku ? '既読' : '未読' }}</td>
              </template>

            </template>
            
            <!-- <td class="period">{{ DateUtil.format(item.start_datetime, 'YYYY/MM/DD HH:mm') }}～{{ DateUtil.format(item.end_datetime, 'YYYY/MM/DD HH:mm') }}</td> -->
          </tr>
        </tbody>
      </table>
    </scroll-table>
  </template>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { RouterConst } from '@/const/Router';
import OptionConst from "@/const/Option";
import { DateUtil } from '@/utils/DateUtil';
import { RenrakuList } from '@/types/KaisyaRenraku';
import { OshiraseService } from '@/service/OshiraseService';
import { useAuthStore } from '@/store/auth'; 
import { PermissionConst } from '@/const/Permission';
import router from '@/routers';

export default defineComponent({
  props: {
    list: {
      type: Object as () => RenrakuList[],
      require: true,
      default: null
    },
    isSearching: {
      type: Boolean,
      require: true,
      default: false
    },
    dataType: {
      type: Number,
      require: true,
    },
  },
  setup(props) {
    const oshiraseService = new OshiraseService();

    const authStore = useAuthStore();

    const onClick = async(oshiraseId: number, isUnRead: Boolean) =>{
      if(isUnRead){
        await oshiraseService.updateToRead(oshiraseId);
      }
      const type = props.dataType == OptionConst.RENRAKU_SERACH_TYPE.RECEIVE ? OptionConst.RENRAKU_VIEW_TYPE.RECEIVE : OptionConst.RENRAKU_VIEW_TYPE.SEND 
      router.push({name: RouterConst.RENRAKU_DETAIL, params: { type: type, oshiraseId: oshiraseId }})
    }

    return {
      RouterConst,
      OptionConst,
      DateUtil,
      onClick,
      authStore,
      PermissionConst,
    }
  },
  components: {
  }
})
</script>
<style lang="scss" scoped>
@import "@scss/components/renraku-search.scss";
</style>